<template>
  <div class="minW1060-auto bg-fff mag10 pad10">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="待审核" name="1"></el-tab-pane>
      <el-tab-pane label="已通过" name="2"></el-tab-pane>
      <el-tab-pane label="未通过" name="3"></el-tab-pane>
    </el-tabs>

    <el-row class="text-left">

      <div class="dlblock-mb20 mr10">
        <span class="pr5">用户名</span>
        <el-input v-model.trim="userName" placeholder="请输入" style="width: 150px;"/>
      </div>

      <div class="dlblock-mb20 mr10">
        <span class="pr5">所属代理商</span>
          <el-input v-model.trim="superAgentName" placeholder="请输入" style="width: 150px;"/>
      </div>

      <div class="dlblock-mb20 mr10">
        <span class="pr5">申请日期</span>
        <el-date-picker
            v-model="date"
            style="width: 300px;"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"/>
      </div>
      <div class="dlblock-mb20 mr10">
        <span class="pr5">类型</span>
        <el-select v-model="withdrawType" class="w150" placeholder="不限" clearable>
          <el-option v-for="(item, index) in withdrawTypeObj" :key="index" :label="item.name" :value="item.value"/>
        </el-select>
      </div>
      <div class="dlblock-mb20">
        <el-button type="primary" @click="pages.page = 1; getWalletWithdrawApplyPageFn()">
          搜索
        </el-button>
        <el-button type="primary" @click="cashofferSettings()">
          提现设置
        </el-button>
      </div>
    </el-row>

    <el-table class="my-table" :data="tableData" v-loading="tableLoading" key="1" :header-row-class-name="'my-table-header'">
        <el-table-column align="center" prop="userName" label="用户名"></el-table-column>
        <el-table-column align="center" prop="superAgentName" label="所属代理商"></el-table-column>
        <el-table-column align="center" prop="phone" label="手机号"></el-table-column>
        <el-table-column align="center" prop="withdrawType.desc" label="提现类型">
            <template slot-scope="{row}">
             {{row.withdrawType && row.withdrawType.desc}}
            </template>
        </el-table-column>
        <el-table-column align="center" prop="withdrawAmount" label="提现金额"></el-table-column>
        <el-table-column align="center" prop="walletBalance" label="余额"></el-table-column>
        <el-table-column align="center" prop="applyTime" label="申请日期"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="{row}">
            <a class="glob-a" v-if="activeName == '1'" @click="statusBtn(1,row)" >审核</a>
            <a class="glob-a" v-if="activeName == '2'" @click="statusBtn(2,row)" >查看</a>
            <a class="glob-a" v-if="activeName == '3'" @click="statusBtn(2,row)" >查看</a>
          </template>
        </el-table-column>
    </el-table>


    <div class="my-pagination">
      <el-pagination background layout="total, prev, pager, next" :total="pages.total"
                     :current-page="pages.page" @current-change="pageChange">
      </el-pagination>
    </div>

    <!-- 审核 -->
    <el-dialog title="审核" :visible.sync="auditShow.modal" width="800px">
      <el-form label-width="170px">

        <el-row>
          <el-col :span="12">
            <el-form-item label="用户名：">
              {{auditShow.data.userName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：">
              {{auditShow.data.phone}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="所属代理商：">
              {{auditShow.data.superAgentName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="提现类型：">
              {{auditShow.data.withdrawType ? auditShow.data.withdrawType.desc : ''}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="提现金额：">
              {{auditShow.data.withdrawAmount}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="余额：">
              {{auditShow.data.walletBalance}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="持卡人：">
              {{auditShow.data.cardHolder}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行：">
              {{auditShow.data.bankName}}
            </el-form-item>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="12">
            <el-form-item label="卡号：">
              {{auditShow.data.cardNo}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请日期：">
              {{auditShow.data.applyTime}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="审核意见：">
              <el-radio v-model="radio"  label="PASS" >审核通过</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核不通过：">
            <el-radio v-model="radio"  label="NOT_PASS" >&nbsp;</el-radio>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="未通过原因：" v-if="auditShow.data.status && auditShow.data.status.name == 'NOT_PASS'">
          {{auditShow.data.remark}}
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="auditShow.modal = false">取 消</el-button>
        <el-button type="primary" @click="determineBtn()">确 定</el-button>
      </div>
    </el-dialog>


    <!-- 查看 -->
    <el-dialog title="查看" :visible.sync="auditShowDetail.modal" width="800px">
      <el-form label-width="170px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户名：">
              {{auditShowDetail.data.userName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：">
              {{auditShowDetail.data.phone}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="所属代理商：">
              {{auditShowDetail.data.superAgentName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="提现类型：">
                {{auditShowDetail.data.withdrawType ? auditShowDetail.data.withdrawType.desc : ''}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="提现金额：">
              {{auditShowDetail.data.withdrawAmount}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="余额：">
              {{auditShowDetail.data.walletBalance}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="持卡人：">
              {{auditShowDetail.data.cardHolder}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行：">
              {{auditShowDetail.data.bankName}}
            </el-form-item>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="12">
            <el-form-item label="卡号：">
              {{auditShowDetail.data.cardNo}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请日期：">
              {{auditShowDetail.data.applyTime}}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12" v-if="activeName == '2' || activeName == '3'">
            <el-form-item label="状态：">
                {{auditShowDetail.data.status ? auditShowDetail.data.status.desc : ''}}
            </el-form-item>
          </el-col>


          <el-col :span="12" v-if="activeName == '3'">
            <el-form-item label="备注：">
              {{auditShowDetail.data.remark}}
            </el-form-item>
          </el-col>

        </el-row>

      </el-form>

    </el-dialog>

      <!-- 提现设置 -->
      <el-dialog title="提现设置" :visible.sync="cashOfferSettings.modal" width="500px">
          <el-form label-width="160px">
              <el-form-item label="通用余额最低提现金额">
                  <el-input v-model.trim="cashOfferSettings.minNormalBalanceWithdrawAmount" type="number" placeholder="请输入"/>
              </el-form-item>
              <el-form-item label="广告余额最低提现金额">
                  <el-input v-model.trim="cashOfferSettings.minAdBalanceWithdrawAmount" type="number" placeholder="请输入"/>

              </el-form-item>
          </el-form>

          <div slot="footer">
              <el-button @click="cashOfferSettings.modal = false">取 消</el-button>
              <el-button type="primary" @click="editSave()">确 定</el-button>
          </div>
      </el-dialog>

  </div>
</template>

<script>
  import {
    getWalletWithdrawApplyPage,
    walletWithdrawApplyAudit,
    walletWithdrawApplyConfig
  } from '@/api'
  export default {
    name: 'Wallet',
    data () {
      return {
        date: '',
        tableData: [],
        tableLoading: false,
        activeName: '1',
        pages: {
          page: 1,
          total: 0
        },
        superAgentName:'',
        userName:'',
        withdrawType:'',
        withdrawTypeObj:[{name:'通用余额',value:'NORMAL'},{name:'广告余额', value:'AD'}],
        //tab 默认加载待审核
        status: 'UNTREATED',
        //提现设置
        cashOfferSettings:{modal:false},
        auditShow: {
          modal: false,
          data: {}
        },
        auditShowDetail:{
                  modal: false,
                  data: {}
                },
        radio:'',
        toExamine:{
          withdrawApplyId: '',
          status: '',
          remark: ''
        }
      }
    },
    created(){
        this.getWalletWithdrawApplyPageFn()
    },
    methods: {
      handleClick (val) {
        this.refresh(1);
      },
      refresh (page) {
        //page && (this.Pages.page = page)
        switch (this.activeName) {
          case '1':
            //待审核
            this.status = "UNTREATED"
            this.getWalletWithdrawApplyPageFn()
            break
          case '2':
            //已审核
            this.status = "PASS"
            this.getWalletWithdrawApplyPageFn()
            break
          case '3':
            //未通过
            this.status = "NOT_PASS"
            this.getWalletWithdrawApplyPageFn()
            break
        }
      },
      pageChange (val) {
        this.pages.page = val
        this.getWalletWithdrawApplyPageFn()
      },
      getWalletWithdrawApplyPageFn () {
        this.tableLoading = true
        getWalletWithdrawApplyPage({
          pageNum: this.pages.page,
          userName: this.userName,
          superAgentName: this.superAgentName,
          startApplyTime: this.date && this.date.length ? this.date[0] : '',
          endApplyTime: this.date && this.date.length > 1 ? this.date[1] : '',
          withdrawType: this.withdrawType,
          status: this.status,
        }).then(res => {
          this.tableData = res.data.list
          this.pages.total = res.data.count
        }).finally(() => {
          this.tableLoading = false
        })
      },
      walletWithdrawApplyAuditFn(){
        walletWithdrawApplyAudit({
          withdrawApplyId: this.toExamine.withdrawApplyId,
          status: this.toExamine.status,
          remark: this.toExamine.remark
        }).then(res => {
          //审核成功关闭弹框
          this.auditShow.modal = false;
        }).finally(() => {
          this.tableLoading = false
        })
      },
        //1查看 2修改
      walletWithdrawApplyConfigFn(t){

          if( t == 1){
              //提现设置关闭弹框
              this.cashOfferSettings.modal = true;
              walletWithdrawApplyConfig({
                  minNormalBalanceWithdrawAmount: this.cashOfferSettings.minNormalBalanceWithdrawAmount,
                  minAdBalanceWithdrawAmount: this.cashOfferSettings.minAdBalanceWithdrawAmount,
              }).then(res => {
                  this.cashOfferSettings = {
                      modal:true,
                      minNormalBalanceWithdrawAmount : res.minNormalBalanceWithdrawAmount,
                      minAdBalanceWithdrawAmount : res.minAdBalanceWithdrawAmount
                  }

              }).finally(() => {
                  this.tableLoading = false
              })
          }else if(t == 2){
              walletWithdrawApplyConfig({
                  minNormalBalanceWithdrawAmount: this.cashOfferSettings.minNormalBalanceWithdrawAmount,
                  minAdBalanceWithdrawAmount: this.cashOfferSettings.minAdBalanceWithdrawAmount,
              }).then(res => {
                  //提现设置关闭弹框
                  this.cashOfferSettings.modal = false;
              }).finally(() => {
                  this.tableLoading = false
              })
          }
        },
      // t: 1审核 2查看
      statusBtn (t, row) {
        if (t == 1) {
          this.auditShow = {
            modal: true,
            data: {
              userName:row.userName,
              phone:row.phone,
              superAgentName:row.superAgentName,
              withdrawType:row.withdrawType,
              withdrawAmount:row.withdrawAmount,
              walletBalance:row.walletBalance,
              cardHolder:row.cardHolder,
              bankName:row.bankName,
              cardNo:row.cardNo,
              applyTime:row.applyTime,
              remark:row.remark,
              withdrawApplyId:row.withdrawApplyId,
              status:row.status
            }
          }
        }else if(t == 2){
          this.auditShowDetail = {
            modal: true,
            data: {
              userName:row.userName,
              phone:row.phone,
              superAgentName:row.superAgentName,
              withdrawType:row.withdrawType,
              withdrawAmount:row.withdrawAmount,
              walletBalance:row.walletBalance,
              cardHolder:row.cardHolder,
              bankName:row.bankName,
              cardNo:row.cardNo,
              applyTime:row.applyTime,
              remark:row.remark,
              withdrawApplyId:row.withdrawApplyId,
              status:row.status
            }
          }
        }
      },
      // 确定
      determineBtn(){
        this.toExamine = {
          withdrawApplyId: this.auditShow.data.withdrawApplyId,
          status: this.radio,
          remark: this.auditShow.data.remark,
        }
        this.walletWithdrawApplyAuditFn();
      },
      //提现设置查看
      cashofferSettings(){
          this.walletWithdrawApplyConfigFn(1);
      },
       //提现设置修改
      editSave(){
          this.walletWithdrawApplyConfigFn(2);
      }
    }
  }
</script>

<style scoped>

</style>
